/* eslint-disable @typescript-eslint/no-deprecated */
import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { provideRouter } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppLibModule } from 'applib';
import { ConfigService, MssLibModule, provideMssFormly } from 'msslib';
import { environment } from '../environments/environment';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      FormsModule,
      ReactiveFormsModule,
      MssLibModule.forRoot(environment.mssLibConfig),
      AppLibModule,
    ),
    provideAppInitializer(() => inject(ConfigService).load()),
    provideMssFormly(),
  ],
};
